import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap');

  :root {
    --foreground-rgb: 0, 0, 0; 
    --background-rgb: 252, 250, 238; 
  }

  @media (prefers-color-scheme: dark) {
    :root {
      --foreground-rgb: 0, 0, 0;
      --background-rgb: 252, 250, 238; 
    }
  }

  * {
    box-sizing: border-box;
  }

  body {
    color: rgb(var(--foreground-rgb));
    background: rgb(var(--background-rgb));
    width: 100%;
    margin: 0;
    font-family: 'Helvetica', sans-serif; 
  }

  span, p, li, a { 
    font-family: 'Helvetica', sans-serif; 
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: "PT Serif", serif;
  }

  h1 {
    font-weight: 700; /* Bold */
  }

  h2, h3, h4, h5, h6 {
    font-weight: 400; /* Regular */
  }

  .pt-serif-regular {
    font-family: "PT Serif", serif;
    font-weight: 400;
    font-style: normal;
  }

  .pt-serif-bold {
    font-family: "PT Serif", serif;
    font-weight: 700;
    font-style: normal;
  }

  .pt-serif-regular-italic {
    font-family: "PT Serif", serif;
    font-weight: 400;
    font-style: italic;
  }

  .pt-serif-bold-italic {
    font-family: "PT Serif", serif;
    font-weight: 700;
    font-style: italic;
  }

  .-no-overflow {
    overflow: hidden;
  }

  input:-internal-autofill-selected {
    background-color: transparent !important;
    background-image: none !important;
    color: rgb(var(--foreground-rgb)) !important;
    background: transparent !important;
  }
`;
